<template>
  <!-- Add Quiz -->
  <div class="modal fade" id="add-quiz">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5>Add Quiz Question</h5>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="isax isax-close-circle5"></i>
          </button>
        </div>
        <form @submit.prevent="submitQuiz">
          <div class="modal-body">
            <!-- Course -->
            <div class="input-block mb-3">
              <label class="form-label"
                >Lesson (Video)</label
              >
              <vSelect
                class="vselect-custom"
                :options="videoContents"
                label="title"
                :reduce="(group) => group.localIndex"
                id="course-category"
                placeholder="Lesson"
                v-model="CourseDataStore.QuizDraft.content_local_index"
              />
            </div>
            <!-- Pertanyaan -->
            <div class="input-block mb-3">
              <label class="form-label"
                >Question</label
              >
              <textarea
                v-model="CourseDataStore.QuizDraft.question"
                class="form-control"
                required
              ></textarea>
            </div>

            <!-- Waktu Muncul -->
            <div class="input-block mb-3">
              <label class="form-label"
                >Popup Time (in seconds)
                <span class="text-danger">*</span>
                <i
                  class="isax isax-info-circle ms-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="Detik ke berapa quiz muncul saat video diputar."
                ></i>
              </label>
              <input
                v-model="CourseDataStore.QuizDraft.popup_time"
                type="number"
                min="0"
                class="form-control"
                required
              />
            </div>

            <!-- Pilihan Jawaban -->
            <div class="input-block mb-3">
              <label class="form-label">Option A</label>
              <input
                v-model="CourseDataStore.QuizDraft.option_a"
                type="text"
                class="form-control"
              />
            </div>
            <div class="input-block mb-3">
              <label class="form-label">Option B</label>
              <input
                v-model="CourseDataStore.QuizDraft.option_b"
                type="text"
                class="form-control"
              />
            </div>
            <div class="input-block mb-3">
              <label class="form-label">Option C</label>
              <input
                v-model="CourseDataStore.QuizDraft.option_c"
                type="text"
                class="form-control"
              />
            </div>
            <div class="input-block mb-3">
              <label class="form-label">Option D</label>
              <input
                v-model="CourseDataStore.QuizDraft.option_d"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Jawaban Benar -->
            <div class="input-block mb-3">
              <label class="form-label">Correct Answer</label>
              <select
                v-model="CourseDataStore.QuizDraft.correct_answer"
                class="form-control"
                required
              >
                <option disabled value="">Select the correct answer</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
                <option value="D">D</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn me-2 btn-light"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-secondary">Add Quiz</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add Quiz -->

  <!-- Add lesson -->
  <div class="modal fade" id="add-lesson">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5>New Lessons</h5>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="isax isax-close-circle5"></i>
          </button>
        </div>

        <form @submit.prevent="submitLesson">
          <div class="modal-body">
            <div class="input-block mb-4">
              <label class="form-label"
                >Content Type<span class="text-danger ms-1">*</span></label
              >
              <select
                v-model="CourseDataStore.contentDraft.type"
                class="form-control"
                required
              >
                <option value="" disabled>Pilih tipe konten</option>
                <option value="Video">Video</option>
                <option value="PDF">PDF</option>
                <option value="File PPT">File PPT</option>
              </select>
            </div>

            <div class="input-block mb-4">
              <label class="form-label"
                >Title<span class="text-danger ms-1">*</span></label
              >
              <input
                type="text"
                class="form-control"
                v-model="CourseDataStore.contentDraft.title"
                placeholder="Title"
                required
              />
            </div>

            <!-- File Upload -->
            <div class="input-block mb-4">
              <label class="form-label"
                >File Upload<span class="text-danger ms-1">*</span></label
              >
              <div class="custom-file">
                <input
                  ref="lessonFileInput"
                  type="file"
                  id="lessonFileInput"
                  class="custom-file-input"
                  @change="handleLessonFileUpload"
                  :accept="getAcceptByType"
                  :required="!CourseDataStore.contentDraft.filePath"
                />
              </div>
              <small
                v-if="lessonFileHint"
                class="text-muted d-block mt-1"
              >
                {{ lessonFileHint }}
              </small>
            </div>
            <!-- Duration -->
            <!-- <div class="input-block mb-4">
              <label class="form-label"
                >Duration (Seconds) Lesson<span class="text-danger ms-1"
                  >*</span
                >
                <i
                  class="isax isax-info-circle ms-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="Durasi minimal (detik) sebelum bisa lanjut ke konten berikutnya."
                ></i
              ></label>
              <input
                type="number"
                class="form-control"
                v-model="CourseDataStore.contentDraft.duration"
                placeholder="Contoh: 300"
                required
              />
            </div> -->
            <!-- Is Skippable -->
            <!-- <div class="input-block mb-4">
              <label class="form-label">Skipabel?</label>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="CourseDataStore.contentDraft.isSkippable"
                />
                <label class="form-check-label">Yes</label>
              </div>
            </div> -->
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn me-2 btn-light"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-secondary">Add New</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add lesson -->

  <!-- Add Exam -->
  <div class="modal fade" id="add-exam">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5>Add New Exam</h5>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="isax isax-close-circle5"></i>
          </button>
        </div>
        <form @submit.prevent="submitExam">
          <div class="modal-body">
            <div class="input-block mb-4">
              <label class="form-label"
                >Exam Type<span class="text-danger ms-1">*</span></label
              >
              <select
                class="form-control"
                v-model="CourseDataStore.ExamDraft.examType"
                required
              >
                <option value="Written">Written</option>
                <option value="Practical">Practical</option>
                <option value="Both">Both</option>
              </select>
            </div>
            <template v-if="CourseDataStore.ExamDraft.examType !== 'Practical'">
              <div class="input-block mb-4">
                <label class="form-label"
                  >Multiple Choice Weight<span class="text-danger ms-1"
                    >*</span
                  ></label
                >
                <input
                  type="number"
                  class="form-control"
                  v-model="CourseDataStore.ExamDraft.multiple_choice_weight"
                  required
                  placeholder="Contoh: 60"
                />
              </div>
              <div class="input-block mb-4">
                <label class="form-label"
                  >Essay Weight<span class="text-danger ms-1">*</span></label
                >
                <input
                  type="number"
                  class="form-control"
                  v-model="CourseDataStore.ExamDraft.essay_weight"
                  required
                  placeholder="Contoh: 40"
                />
              </div>
              <div class="input-block mb-4">
                <label class="form-label">Time Limit (minutes)</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="CourseDataStore.ExamDraft.time_limit_minutes"
                  min="1"
                />
              </div>
              <div class="input-block mb-4">
                <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <label class="form-label mb-0">Exam Question (.xlsx)</label>
                  <div class="d-flex align-items-center flex-wrap gap-3">
                    <a
                      v-if="isEditMode && existingExamID"
                      href="javascript:void(0);"
                      class="text-primary fw-medium"
                      @click="downloadExistingExamExcel"
                    >
                      <u><i class="isax isax-document-download me-1"></i> Download Soal Sebelumnya</u>
                    </a>
                    <a href="/template/Template-Exam.xlsx" download class="text-secondary">
                      <u>Download Template Excel</u>
                    </a>
                  </div>
                </div>
                <div class="custom-file">
                  <input
                    type="file"
                    id="customFile"
                    class="custom-file-input"
                    @change="handleExamFileUpload"
                    accept=".xlsx"
                  />
                </div>
                <div
                  v-if="isEditMode && existingExamQuestionCount > 0 && CourseDataStore.examQuestionsParsed.length === 0"
                  class="form-text text-muted mt-2 fs-12"
                >
                  <i class="isax isax-info-circle me-1 text-primary"></i>
                  Saat ini terdapat <strong>{{ existingExamQuestionCount }} soal</strong> tersimpan. Unggah file baru hanya jika ingin mengganti soal.
                </div>
                <div
                  v-else-if="CourseDataStore.examQuestionsParsed.length > 0"
                  class="form-text text-success mt-2 fs-12"
                >
                  <i class="isax isax-tick-circle me-1"></i>
                  <strong>{{ CourseDataStore.examQuestionsParsed.length }} soal</strong> baru siap disimpan.
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn me-2 btn-light"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-secondary">Add New</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add Exam -->

  <!-- success -->
  <div class="modal fade modal-default" id="success">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body p-4">
          <div class="text-center">
            <div class="text-success h1 mb-2">
              <i class="isax isax-tick-circle5"></i>
            </div>
            <h5 class="mb-2">Congratulations! Course Submitted</h5>
            <p class="mb-3">
              You’ve successfully Submitted the Course & its under the review,
              Once the course is reviewed by the reviewer it will go live.
            </p>
            <div
              class="d-flex align-items-center justify-content-center gap-2 flex-wrap"
              data-bs-toggle="modal"
              data-bs-target="#success"
            >
              <router-link
                to="/instructor/instructor-dashboard"
                class="btn btn-secondary"
              >
                <i class="isax isax-arrow-left-2 me-1"></i>
                Back to Dashboard
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /success -->
</template>

<script>
import { useCourseDataStore } from "@/stores/course/course-data-store";
import { Modal } from "bootstrap";
import { useSharedStore } from "@/stores/shared-store";

export default {
  setup() {
    const CourseDataStore = useCourseDataStore();
    const sharedStore = useSharedStore();
    return {
      CourseDataStore,
      sharedStore,
    };
  },
  data() {
    return {};
  },
  mounted() {
    const lessonModal = document.getElementById("add-lesson");
    if (lessonModal) {
      lessonModal.addEventListener("show.bs.modal", this.resetLessonFileInput);
    }
  },
  beforeUnmount() {
    const lessonModal = document.getElementById("add-lesson");
    if (lessonModal) {
      lessonModal.removeEventListener(
        "show.bs.modal",
        this.resetLessonFileInput
      );
    }
  },
  methods: {
    closeModal(id) {
      const modalEl = document.getElementById(id);
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      modal.hide();
      setTimeout(() => {
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) backdrop.remove();
        document.body.classList.remove("modal-open");
        document.body.style = ""; // bersihkan style yang ditinggal modal
      }, 500); // cukup waktu untuk animasi close modal
    },
    resetLessonFileInput() {
      this.$nextTick(() => {
        const input = this.$refs.lessonFileInput;
        if (input) input.value = "";
      });
    },
    handleLessonFileUpload(event) {
      const file = event.target.files[0];
      this.CourseDataStore.contentDraft.filePath = file || null;
    },
    handleExamFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // validasi tipe mime
        const allowedTypes = [
          /* "application/vnd.ms-excel", // .xls (Excel 97-2003) */
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx (Excel modern)
        ];

        if (!allowedTypes.includes(file.type)) {
          this.sharedStore.showError(
            "Hanya file Excel (.xlsx) yang diperbolehkan!"
          );
          event.target.value = ""; // reset input
          return;
        }

        this.CourseDataStore.examExcelFile = file;
      }
    },
    submitExam() {
      if (this.CourseDataStore.ExamDraft.examType !== "Practical") {
        this.CourseDataStore.parseExamExcel(this.CourseDataStore.examExcelFile);
      }
      this.CourseDataStore.examConfigured = true;
      console.log(this.CourseDataStore.ExamDraft.examType);

      this.closeModal("add-exam");
    },
    submitQuiz() {
      this.CourseDataStore.saveQuizDraft();

      this.closeModal("add-quiz");
    },
    submitLesson() {
      this.CourseDataStore.saveDraft();
      this.resetLessonFileInput();
      this.closeModal("add-lesson");
    },
    downloadExistingExamExcel() {
      this.CourseDataStore.downloadExistingExamExcel();
    },
  },
  computed: {
    videoContents(){
      return this.CourseDataStore.addCourseContent.filter((item) => item.type === 'Video')
    },
    lessonFileHint() {
      const file = this.CourseDataStore.contentDraft.filePath;
      if (!file) return "";
      if (typeof File !== "undefined" && file instanceof File) {
        return `File dipilih: ${file.name}`;
      }
      if (typeof file === "string") {
        const name = file.split("/").pop();
        return `File saat ini: ${name} (pilih file baru jika ingin mengganti)`;
      }
      return "";
    },
    getAcceptByType() {
      switch (this.CourseDataStore.contentDraft.type) {
        case "Video":
          return "video/mp4,video/mkv,video/webm"; // hanya format video
        case "PDF":
          return "application/pdf";
        case "File PPT":
          return ".ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation";
        default:
          return ""; // default bisa pilih semua
      }
    },
    isEditMode() {
      return !!(
        this.$route.params?.courseID ||
        this.$route.params?.id ||
        this.$route.query?.courseID ||
        this.$route.query?.id ||
        this.$route.name === "CourseEdit" ||
        (this.$route.path && this.$route.path.includes("/edit"))
      );
    },
    existingExamID() {
      return (
        this.CourseDataStore.ExamDraft?.examID ||
        this.CourseDataStore.courseFetchStore?.basicCourseDetail?.exam?.examID ||
        null
      );
    },
    existingExamQuestionCount() {
      return (
        this.CourseDataStore.existingExamQuestionCount ||
        this.CourseDataStore.ExamDraft?.question_count ||
        0
      );
    },
  },
};
</script>

<style scoped>
:where(#add-quiz, #add-lesson, #add-exam) .modal-dialog {
  width: calc(100% - 2rem);
  max-width: 620px;
  margin: 1rem auto;
}

@media (max-width: 575.98px) {
  :where(#add-quiz, #add-lesson, #add-exam) .modal-dialog {
    width: calc(100% - 1rem);
    margin: 0.75rem auto;
  }
}

:where(#add-quiz, #add-lesson, #add-exam) .modal-content {
  border-radius: 12px;
  overflow: hidden;
}

:where(#add-quiz, #add-lesson, #add-exam) .modal-header {
  padding: 1rem 1.25rem;
  gap: 0.75rem;
}

:where(#add-quiz, #add-lesson, #add-exam) .modal-header h5 {
  margin: 0;
  font-weight: 600;
  letter-spacing: 0.1px;
}

:where(#add-quiz, #add-lesson, #add-exam) .modal-body {
  padding: 1.25rem;
}

:where(#add-quiz, #add-lesson, #add-exam) .modal-footer {
  padding: 0.875rem 1.25rem;
  gap: 0.75rem;
}

@media (max-width: 575.98px) {
  :where(#add-quiz, #add-lesson, #add-exam) .modal-body {
    padding: 1rem;
  }

  :where(#add-quiz, #add-lesson, #add-exam) .modal-footer {
    padding: 0.875rem 1rem;
  }

  :where(#add-quiz, #add-lesson, #add-exam) .modal-footer .btn {
    flex: 1 1 100%;
  }
}

:where(#add-quiz, #add-lesson, #add-exam) .input-block .form-label {
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #685f78;
}

:where(#add-quiz, #add-lesson, #add-exam) :is(.form-control, .custom-file-input) {
  min-height: 44px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  background-color: #fff;
  color: #263238;
  transition:
    border-color 150ms ease,
    box-shadow 150ms ease,
    background-color 150ms ease;
}

:where(#add-quiz, #add-lesson, #add-exam) textarea.form-control {
  min-height: 110px;
  resize: vertical;
}

:where(#add-quiz, #add-lesson, #add-exam) :is(.form-control, .custom-file-input):hover {
  border-color: rgba(246, 105, 98, 0.55);
}

:where(#add-quiz, #add-lesson, #add-exam)
  :is(.form-control, .custom-file-input):focus,
:where(#add-quiz, #add-lesson, #add-exam)
  :is(.form-control, .custom-file-input):focus-visible {
  border-color: #f66962;
  box-shadow: 0 0 0 0.25rem rgba(246, 105, 98, 0.22);
  outline: none;
}

:where(#add-quiz, #add-lesson, #add-exam) :is(.form-control, .custom-file-input):disabled {
  background-color: #f8f9fa;
  color: rgba(38, 50, 56, 0.65);
}

:where(#add-quiz, #add-lesson, #add-exam)
  :is(.form-control, .custom-file-input).is-invalid,
:where(#add-quiz, #add-lesson, #add-exam)
  :is(.form-control, .custom-file-input):-moz-ui-invalid,
:where(#add-quiz, #add-lesson, #add-exam)
  :is(.form-control, .custom-file-input):user-invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.18);
}

:where(#add-quiz, #add-lesson, #add-exam) .btn {
  min-height: 44px;
}

:where(#add-quiz, #add-lesson, #add-exam) .btn:focus-visible,
:where(#add-quiz, #add-lesson, #add-exam) .custom-btn-close:focus-visible {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(246, 105, 98, 0.22);
}

:where(#add-quiz, #add-lesson, #add-exam) .custom-file {
  display: flex;
}

:where(#add-quiz, #add-lesson, #add-exam) .custom-file-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
}

:where(#add-quiz, #add-lesson, #add-exam) .custom-file-input::file-selector-button {
  margin-right: 0.75rem;
  padding: 0.45rem 0.9rem;
  border-radius: 999px;
  border: 1px solid rgba(246, 105, 98, 0.5);
  background: rgba(246, 105, 98, 0.1);
  color: #f66962;
  font-weight: 600;
  transition:
    background-color 150ms ease,
    border-color 150ms ease,
    color 150ms ease;
}

:where(#add-quiz, #add-lesson, #add-exam) .custom-file-input::-webkit-file-upload-button {
  margin-right: 0.75rem;
  padding: 0.45rem 0.9rem;
  border-radius: 999px;
  border: 1px solid rgba(246, 105, 98, 0.5);
  background: rgba(246, 105, 98, 0.1);
  color: #f66962;
  font-weight: 600;
  transition:
    background-color 150ms ease,
    border-color 150ms ease,
    color 150ms ease;
}

:where(#add-quiz, #add-lesson, #add-exam) .custom-file-input:hover::file-selector-button,
:where(#add-quiz, #add-lesson, #add-exam) .custom-file-input:hover::-webkit-file-upload-button {
  background: #f66962;
  border-color: #f66962;
  color: #fff;
}

:where(#add-quiz, #add-lesson, #add-exam) :deep(.vselect-custom .vs__dropdown-toggle) {
  min-height: 44px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  padding: 0.25rem 0.75rem;
  background-color: #fff;
  transition:
    border-color 150ms ease,
    box-shadow 150ms ease,
    background-color 150ms ease;
}

:where(#add-quiz, #add-lesson, #add-exam)
  :deep(.vselect-custom .vs__dropdown-toggle:hover) {
  border-color: rgba(246, 105, 98, 0.55);
}

:where(#add-quiz, #add-lesson, #add-exam)
  :deep(.vselect-custom.vs--open .vs__dropdown-toggle),
:where(#add-quiz, #add-lesson, #add-exam)
  :deep(.vselect-custom .vs__dropdown-toggle:focus-within) {
  border-color: #f66962;
  box-shadow: 0 0 0 0.25rem rgba(246, 105, 98, 0.22);
}

:where(#add-quiz, #add-lesson, #add-exam)
  :deep(.vselect-custom .vs__selected-options) {
  padding: 0;
}

:where(#add-quiz, #add-lesson, #add-exam) :deep(.vselect-custom .vs__search) {
  margin: 0;
}

:where(#add-quiz, #add-lesson, #add-exam)
  :deep(.vselect-custom .vs__dropdown-menu) {
  border-radius: 12px;
  border: 1px solid #e9ecef;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.14);
  padding: 0.25rem;
}

:where(#add-quiz, #add-lesson, #add-exam)
  :deep(.vselect-custom .vs__dropdown-option) {
  border-radius: 10px;
  padding: 0.5rem 0.75rem;
}

:where(#add-quiz, #add-lesson, #add-exam)
  :deep(.vselect-custom .vs__dropdown-option--highlight) {
  background: rgba(246, 105, 98, 0.12);
  color: #263238;
}
</style>
